function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
module.exports = _OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;


//////////////////
// WEBPACK FOOTER
// ./node_modules/twilio-sync/node_modules/@babel/runtime/helpers/OverloadYield.js
// module id = 2697
// module chunks = 25